import(/* webpackMode: "eager" */ "/home/runner/_work/psx-react-web/psx-react-web/psx-react-web/src/app/layout.tsx");
